
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 15","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true","focusable":"false"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1 5l5 5 5-5","stroke":"currentColor","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M0 14h12","stroke":"currentColor","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M6 0v10","stroke":"currentColor","stroke-width":"1.5"}})])
          )
        }
      }
    